import { Box, Stack, TextField, Button, Grid, Typography } from '@mui/material'
import useStyles from '../components/MainTitle'
import { motion } from 'framer-motion'
import SocialMediaSection from '../components/SocialMedia'





function Contact() {
  const classes = useStyles()

  return (
    <div>
      <Stack direction="row">
        <Box className={classes.BigTitle}>
          <motion.div initial={{opacity: 0, y: 50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}} >Contact</motion.div>
          <Box className={classes.SmallTitle}>
            <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: 1}}}>
                HIRE ME
              <Box className={classes.afterClass} />
            </motion.div>
          </Box>
        </Box>
      </Stack>
      <motion.div initial={{opacity: 0, x: -50}} animate={{opacity: 1, x: 0, transition: {duration: .6, delay: .6}}}>
        <Stack sx={{margin: "40px 0 20px"}}>
          <Typography component={"h2"} sx={{fontSize: "2rem", color: "primary.main"}}>Just say Hello</Typography>
          <Typography component={"p"}>Let us know more about you !</Typography>
        </Stack>
      </motion.div>
      <Grid spacing={2} container>
        <Grid item xs={12} md={7}>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .6, delay: .8}}}>
            <Box sx={{display: "flex", justifyContent: "flex-start", width: "100%", flexDirection: {xs: "column", md: "row"}}}>
              <Grid item xs={12} md={6} sx={{flex: "1"}} >
                <TextField
                  id="firstname"
                  name="firstname"
                  label="First Name"
                  variant="outlined"
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{flex: "1"}}>
                <TextField
                    id="lastname"
                    name="lastname"
                    label="Last Name"
                    variant="outlined"
                    className={classes.textField}
                    sx={{marginLeft: {xs: "0", md: "10px"}, width: {xs: "100%", md:"calc(100% - 10px)"} }}
                    required
                  />
              </Grid>
            </Box>
          </motion.div>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .6, delay: 1}}}>
            <Box sx={{display: "flex", justifyContent: "flex-start", width: "100%", flexDirection: {xs: "column", md: "row"}}}>
              <Grid item xs={12} md={6} sx={{flex: "1"}}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  className={classes.textField}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{flex: "1"}}>
                <TextField
                    id="phone"
                    name="phone"
                    label="Phone"
                    variant="outlined"
                    className={classes.textField}
                    sx={{marginLeft: {xs: "0", md: "10px"}, width: {xs: "100%", md:"calc(100% - 10px)"} }}
                    required
                  />
              </Grid>
            </Box>
          </motion.div>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .6, delay: 1.2}}}>
            <Box sx={{display: "flex", justifyContent: "flex-start", width: "100%"}}>
              <Grid item xs={12} sx={{flex: "1"}}>
                <TextField
                  id="message"
                  name="message"
                  label="Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  className={classes.textField}
                  required
                />
              </Grid>
            </Box>
          </motion.div>
          <motion.div initial={{opacity: 0, y: -50}} animate={{opacity: 1, y: 0, transition: {duration: .6, delay: 1.4}}}>          
            <Box sx={{display: "flex", justifyContent: "flex-start", width: "100%"}}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submitButton}
            >
              Send
            </Button>
            </Box>
          </motion.div>
        </Grid>
        <Grid item xs={12} md={5} sx={{textAlign: "center", transform: {xs: "translateY(20px)", md: "translateY(-60px)"}, overflow: "hidden"}}>
          <motion.div initial={{opacity: 0, x: 200}} animate={{opacity: 1, x: 0, transition: {duration: .4, delay: 1.4}}}>          
            <Stack>
              <Typography component={"h3"} sx={{color: "primary.main", fontSize: "1.4rem"}}>Contact information</Typography>
              <Typography component={"p"} sx={{color: "grey.main", width: "64%", margin: "20px auto"}}>Sultaniye Mah. 315 Sokak Yenikent Esenyurt Istanbul</Typography>
              <Typography component={"p"} sx={{color: "grey.main", width: "64%", margin: "0px auto"}}>Call us :   +905510356296</Typography>
              <Typography component={"p"} sx={{color: "grey.main", width: "74%", margin: "20px auto"}}>Your satisfaction is my top priority and I am committed to delivering high-quality work with a quick turnaround time.</Typography>
              <Typography component={"h3"} sx={{color: "primary.main", fontSize: "1.4rem", marginTop: "20px"}}>Follow Us</Typography>
              <SocialMediaSection />
            </Stack>
          </motion.div>
        </Grid>
      </Grid>
    </div>
  )
}

export default Contact
